module.exports = __webpack_public_path__ + "static/media/wmata_logo.a884ed0e.png";